// C:\VUE3\platform\src\composables\useSupportCheck.js
import { computed } from "vue";

const MIN = Object.freeze({
  chrome: 49,
  edge: 79,
  firefox: 18,
  safari: 10,     // macOS Safari
  ios_saf: 10,    // iOS Safari
  opera: 36,
  samsung: 5
});

function detectUA() {
  const ua = navigator.userAgent || "";
  const isIOS = /\b(iPhone|iPad|iPod)\b/i.test(ua);
  const inAppMatch = ua.match(/KAKAOTALK|Instagram|FBAN|FBAV|NAVER|Line|MicroMessenger/i);
  const inApp = !!inAppMatch;
  const inAppName = inAppMatch ? inAppMatch[0] : null;

  // Order matters (Edg, OPR, Samsung, Chrome, Firefox, Safari)
  let family = "unknown", major = 0;

  let m;
  if ((m = ua.match(/Edg\/(\d+)/))) { family = "edge"; major = parseInt(m[1], 10); }
  else if ((m = ua.match(/OPR\/(\d+)/))) { family = "opera"; major = parseInt(m[1], 10); }
  else if ((m = ua.match(/SamsungBrowser\/(\d+)/))) { family = "samsung"; major = parseInt(m[1], 10); }
  else if ((m = ua.match(/Firefox\/(\d+)/))) { family = "firefox"; major = parseInt(m[1], 10); }
  else if ((m = ua.match(/Chrome\/(\d+)/)) && !/OPR|Edg/.test(ua)) { family = "chrome"; major = parseInt(m[1], 10); }
  // Safari (macOS / iOS)
  else if ((m = ua.match(/Version\/(\d+).+Safari/))) {
    family = isIOS ? "ios_saf" : "safari";
    major = parseInt(m[1], 10);
  }

  return { ua, family, major, isIOS, inApp, inAppName };
}

function featureDetect() {
  const cssVars = !!(window.CSS && CSS.supports && CSS.supports("color", "var(--x)"));
  const proxy = (() => { try { // Vue3 필수
    // eslint-disable-next-line no-new
    new Proxy({}, {});
    return true;
  } catch { return false; }})();
  const idb = "indexedDB" in window;
  const mse = "MediaSource" in window;
  const webgl = (() => {
    try {
      const c = document.createElement("canvas");
      return !!(c.getContext("webgl") || c.getContext("experimental-webgl"));
    } catch { return false; }
  })();

  return { cssVars, proxy, idb, mse, webgl };
}

export function useSupportCheck() {
  const ua = detectUA();
  const feat = featureDetect();

  // 필수(essential): Vue3 동작에 반드시 필요
  const essentialOK = feat.proxy && feat.cssVars;

  // 버전 기준: 알 수 없는 브라우저는 보수적으로 "버전 미확정" 처리(=표시만)
  const min = MIN[ua.family];
  const meetsMinVersion = (typeof min === "number") ? (ua.major >= min) : false;

  // 권장 기능: 대용량/3D/동영상 사용성 향상
  const recommendedOK = feat.idb && (feat.webgl || ua.family === "safari") && (feat.mse || ua.family === "ios_saf");

  const level = computed(() => {
    if (!essentialOK) return "blocked";        // 핵심 기능 부족 → 하드 게이트 후보
    if (meetsMinVersion) return "supported";   // 정책상 지원
    return "warn";                              // 필수는 통과했지만 버전 미달/미확정 → 경고만
  });

  const summary = computed(() => ({
    family: ua.family,
    version: ua.major || null,
    inApp: ua.inApp,
    inAppName: ua.inAppName,
    essentialOK,
    meetsMinVersion,
    recommendedOK,
    features: feat,
    minVersion: min || null,
    level: level.value
  }));

  return { summary };
}
